import React, { useState,useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import StickyHeader from "../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import Loader from "../../../../components/ACS-Dashboard/ACS-Blocks/Loader";
import Stops from "./edi850/stops850";
import Items from "./edi850/items850";

const CreateShipmentTab = ({ setActiveTab, tabs }) => {
  const navigate = useNavigate();
  const officeCodeFromCookie = Cookies.get("officeCode") || "-";
  const headerRef = useRef(null);
  const [isTemplateSaved, setIsTemplateSaved] = useState(false);
  
  const [formData, setFormData] = useState({
    shipmentNumber: "sh101",
    paymentMethod: "PREPAID",
    poNumber: "243534",
    orderValue: "242334",
    requestedMode: "FTL",
    officeCode: officeCodeFromCookie,
    stops: [],
    items: []
  });
  
  const templates = ["Default Template"];
  const handleInfoChange = (field, newValue) => {
    setInfoData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value: newValue,
      },
    }));
  
    // Sync to formData if relevant
    if (field === "Shipment number") {
      setFormData((prev) => ({
        ...prev,
        shipmentNumber: newValue,
      }));
    }
  
    if (field === "Payment type") {
      setFormData((prev) => ({
        ...prev,
        paymentMethod: newValue,
      }));
    }
  
    if (field === "Shipment date") {
      // example: store if needed
    }
  
    if (field === "Delivery date request") {
      // example: store if needed
    }
  };
  
  const [infoData, setInfoData] = useState({
    "Shipment date": { type: "date", value: "", readonly: false },
    "Shipment number": { type: "text", value: formData.shipmentNumber, readonly: false },
    "Delivery date request": { type: "date", value: "", readonly: false },
    "Payment type": {
      type: "dropdown",
      value: formData.paymentMethod,
      options: ["Credit Card", "Bank Transfer", "COD"],
      readonly: false,
    }

  });
  
  const [loading, setLoading] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/Createfrom850`,
        formData
      );
      console.log("Shipment created:", res.data);

      setFadeOut(true);
      setTimeout(() => {
        const shipmentListTabIndex = tabs.findIndex(tab => tab.id === "shipment-list");
        if (shipmentListTabIndex !== -1) {
          setActiveTab({ index: shipmentListTabIndex });
        }
      }, 500);
    } catch (err) {
      console.error("Error creating shipment:", err);
      alert("Failed to create shipment");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const updateStops = (updatedStops) => {
    setFormData((prev) => ({ ...prev, stops: updatedStops }));
  };

  const updateItems = (updatedItems) => {
    setFormData((prev) => ({ ...prev, items: updatedItems }));
  };

  const buttons = [
    { label: "Save Shipment", type: "primary", onClick: handleSubmit },
    { label: "Save as Draft", type: "secondary", onClick: () => alert("Save as draft coming soon!") },
  ];

  return (
    <div className={`w-full h-full min-h-0 flex flex-col transition-opacity duration-500 ${fadeOut ? "opacity-0" : "opacity-100"}`}>
      {loading ? (
        <Loader message="Creating shipment..." />
      ) : (
        <>
         <div ref={headerRef} className="sticky  top-0 z-10 bg-white shadow-md w-full">
                <StickyHeader
                    infoData={infoData}
                    onInfoChange={handleInfoChange}
                    templates={templates}
                    onSelectTemplate={(template) => console.log(`Selected: ${template}`)}
                    buttons={buttons}
                    saveTemplateConfig={{
                        checked: isTemplateSaved,
                        onChange: () => setIsTemplateSaved((prev) => !prev),
                    }}
                />
            </div>

          <div className="flex-1 overflow-y-auto bg-white w-full p-fluid-1">
            <div className="bg-white rounded-[clamp(0.75rem,1vw,1.5rem)] shadow-fluid-card p-fluid-2">
              <h2 className="text-fluid-3xl font-bold mb-fluid-2">Create Shipment <span className="text-fluid-base font-normal text-gray-500">- {formData.officeCode}</span></h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div>
                  <label className="block font-medium mb-1">Shipment Number</label>
                  <input type="text" name="shipmentNumber" value={formData.shipmentNumber} onChange={handleChange} className="border rounded-md p-2 w-full" />
                </div>
                <div>
                  <label className="block font-medium mb-1">Payment Method</label>
                  <input type="text" name="paymentMethod" value={formData.paymentMethod} onChange={handleChange} className="border rounded-md p-2 w-full" />
                </div>
                <div>
                  <label className="block font-medium mb-1">PO Number</label>
                  <input type="text" name="poNumber" value={formData.poNumber} onChange={handleChange} className="border rounded-md p-2 w-full" />
                </div>
                <div>
                  <label className="block font-medium mb-1">Order Value</label>
                  <input type="number" name="orderValue" value={formData.orderValue} onChange={handleChange} className="border rounded-md p-2 w-full" />
                </div>
                <div>
                  <label className="block font-medium mb-1">Requested Mode</label>
                  <select name="requestedMode" value={formData.requestedMode} onChange={handleChange} className="border rounded-md p-2 w-full">
                    <option value="FCL">FCL</option>
                    <option value="LCL">LCL</option>
                    <option value="AIR">AIR</option>
                    <option value="PARCEL">PARCEL</option>
                    <option value="FTL">FTL</option>
                  </select>
                </div>
              </div>

              <Stops stops={formData.stops} onStopsChange={updateStops} />
              <Items items={formData.items} onItemsChange={updateItems} />

              {/* <div className="mt-fluid-4 flex">
                <Button
                  text="Submit Shipment"
                  backgroundColor="green"
                  textColor="white"
                  padding="clamp(0.5rem,0.8vw,1rem)_clamp(1.5rem,2vw,2.5rem)"
                  fontSize="fluid-lg"
                  borderRadius="clamp(1.5rem,2vw,2rem)"
                  onClick={handleSubmit}
                />
              </div> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateShipmentTab;
